<template>
  <GlobalLoading :only-loading="true" />
  <a-config-provider size="mini">
    <AppProvider>
      <router-view v-slot="{ Component, route }">
        <keep-alive>
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
      </router-view>
      <!-- <global-setting /> -->
    </AppProvider>
  </a-config-provider>
  <!--  <reload-prompt />-->
</template>

<script lang="ts" setup>
  // import enUS from '@arco-design/web-vue/es/locale/lang/en-us';
  // import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn';
  // import GlobalSetting from '@/components/global-setting/index.vue';
  // import useLocale from '@/hooks/locale';
  import AppProvider from '@/components/provider/index.vue';
  import GlobalLoading from '@/components/globalLoading.vue';
  import {
    isElectronSinglePage,
    // useElectronStoreSync,
    useTabBarSyncForSinglePage,
  } from '@/utils/electronHelper';
  // import ReloadPrompt from '@/components/reloadPrompt.vue';

  // useElectronStoreSync();
  useTabBarSyncForSinglePage();

  if (isElectronSinglePage()) {
    // 动态添加全局样式，不然打包后会影响网页端的样式
    const style = document.createElement('style');
    style.innerHTML = `
      #app {
        width: calc(100% - 2px) !important;
        height: 100vh !important;
        background-color: #f2f3f5 !important;
        overflow-y: auto;
        overflow-x: hidden;
      }
      #app > .container > iframe {
        width: 100% !important;
        height: calc(100vh - 5px) !important;
      }
      .vh100-46 {
        height: 100vh !important;
      }
    `;
    document.head.appendChild(style);
  }

  // const { currentLocale } = useLocale();
  // const locale = computed(() => {
  //   switch (currentLocale.value) {
  //     case 'zh-CN':
  //       return zhCN;
  //     case 'en-US':
  //       return enUS;
  //     default:
  //       return enUS;
  //   }
  // });
</script>

<style lang="less">
  //#app {
  //  width: calc(100% - 2px) !important;
  //  height: 100vh !important;
  //
  //  & > .container > iframe {
  //    width: 100% !important;
  //    height: calc(100vh - 5px) !important;
  //  }
  //}
  //
  //.vh100-46 {
  //  height: 100vh !important;
  //}

  //.footer-fixed {
  //  padding-left: 0 !important;
  //  bottom: 48px !important;
  //}
</style>
